<template>
  <div class="show-search" style="display: block;">
    <div class="search-box-container">
      <object
        class="search-icon"
        :data="searchSvg"
        type="image/svg+xml"
      ></object>
      <input
        type="text"
        id="search-fields"
        placeholder="Search"
        :value="searchValue"
        @input="setSearchValueLocal($event.target.value)"
        @keydown.enter="searchLocal"
        ref="searchInput"
        autocomplete="off"
      />
      <a
        href="#"
        class="search-close-icon"
        @click="setSearchValueLocal('')"
        v-if="searchValue.length > 0"
      >
        <object :data="cancelSvg" type="image/svg+xml"></object>
      </a>
      <a href="#" class="search-cancel" @click.stop.prevent="hideSearchLocal">Cancel</a>
    </div>
    <!--<div
      class="filter-search"
      v-show="showDeepSearch && userRole !== 22 && userRole !== 25"
    >-->
    <div
      class="filter-search"
      v-show="showDeepSearch"
    >
      <div class="search-range">
        <p>Searches chats:</p>
      </div>
      <div class="modify-search">
        <div class="sr-con1" ref="start-link">
          <div class="form-group">
            <label for="from-date">From:</label>
            <input
              :value="formattedStartDate"
              type="date"
              name="search-from"
              ref="start-input"
              class="anonymous-input"
              @change="changeDate($event, 'setStartDate')"
            />
          </div>
          <a href="#" @click.prevent>
            <img src="../../../assets/img/m_calendar.png" alt="Stop Calendar" />
          </a>
        </div>
        <div class="sr-con2" ref="end-link">
          <div class="form-group">
            <label for="to-date">To:</label>
            <input
              :value="formattedEndDate"
              type="date"
              name="search-to"
              ref="end-input"
              class="anonymous-input"
              @change="changeDate($event, 'setEndDate')"
            />
          </div>
          <a href="#" @click.prevent>
            <img src="../../../assets/img/m_calendar.png" alt="Stop Date" />
          </a>
        </div>
        <div class="sr-con3">
          <button @click.prevent="filterSearch" type="submit">
            Go
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { dateAndTimeMixin } from "../../../mixins/dateAndTimeMixin";
  import { mapGetters, mapMutations, mapActions } from "vuex";

  export default {
    mixins: [dateAndTimeMixin],
    data() {
      return {
        searchSvg: require("../../../assets/svg/search-icon-input.svg"),
        cancelSvg: require("../../../assets/svg/cancel.svg"),
        showDeepSearch: true
      };
    },
    props: {
      hideSearch: Function
    },
    computed: {
      ...mapGetters({
        searchValue: "getSearchValue",
        searchResults: "getSearchResults",
        startDate: "getStartDate",
        endDate: "getEndDate",
        searching: "getSearching",
        userRole: "getUserRole"
      }),
      formattedStartDate() {
        return this.formatDate({
          dayOfMonth: this.startDate.dayOfMonth,
          month: this.startDate.month,
          year: this.startDate.year
        });
      },
      formattedEndDate() {
        return this.formatDate({
          dayOfMonth: this.endDate.dayOfMonth,
          month: this.endDate.month,
          year: this.endDate.year
        });
      }
    },
    methods: {
      ...mapMutations({
        setSearchValue: "setSearchValue",
        setStartDate: "setStartDate",
        setEndDate: "setEndDate",
        emptySearchAll: "emptySearchAll",
        clearResults: "clearResults"
      }),
      ...mapActions({
        search: "search",
        getFormDetails: "getFormDetails"
      }),
      searchLocal() {
        // if (this.userRole !== 22 && this.userRole !== 25) {
          this.search();
        // }
      },
      filterSearch() {
        this.hideSearch();
      },
      ...mapActions("clients", {
        getClientDetails: "getClientDetails"
      }),
      hideSearchLocal() {
        this.setSearchValue("");
        this.hideSearch();
      },
      setSearchValueLocal(value) {
        this.setSearchValue(value);
        this.clearResults();
      },
      changeDate(event, firstOrLast) {
        // Step 1: Generate the proper format for setting the date
        const date = event.target.value.split("-");
        const year = parseInt(date[0]);
        const month = parseInt(date[1]) - 1;
        const day = parseInt(date[2]);

        // Step 2: Setting the date in the global vue js state
        if (!isNaN(day) && !isNaN(month) && !isNaN(day)) {
          this[firstOrLast]({
            dayOfMonth: day,
            month: month,
            year: year
          });
        }
      }
    },
    components: {
    },
    mounted() {
      this.$refs.searchInput.focus();
      this.$nextTick(() => {
        this.$refs["start-link"].addEventListener("click", () => {
          this.$refs["start-input"].click();
          this.$refs["start-input"].focus();
        });
        this.$refs["end-link"].addEventListener("click", () => {
          this.$refs["end-input"].click();
          this.$refs["end-input"].focus();
        });
      });
    },
    created() {
      // Step 1: Set the to and from date
      const currDate = new Date();
      const start = new Date(currDate.setMonth(currDate.getMonth() - 3));
      const end = new Date(currDate.setMonth(currDate.getMonth() + 6));

      this.setStartDate({
        dayOfMonth: start.getDate(),
        month: start.getMonth(),
        year: start.getFullYear()
      });
      this.setEndDate({
        dayOfMonth: end.getDate(),
        month: end.getMonth(),
        year: end.getFullYear()
      });

      // Step 2: Get client and form details
      if (this.userRole !== 22 && this.userRole !== 25) {
        // this.getFormDetails();
        // this.getClientDetails();
      }
    },
    beforeDestroy() {
      let searchString = this.searchValue;
      this.emptySearchAll();
      this.setSearchValue(searchString);
    }
  };
</script>

<style scoped>
  button[type="submit"] {
    background: #d26d13;
    color: #fff;
    border: none;
    cursor: pointer;
    font-weight: bold;
    border-radius: 3px;
    -webkit-border-radius: 3px;
    -moz-border-radius: 3px;
  }

  .anonymous-input {
    border: none;
    outline: none;
    background-color: transparent;
    font-size: 12px;
  }

  .anonymous-input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    width: 0;
    display: none;
    opacity: 0;
  }

  .anonymous-input::-webkit-calendar-picker-indicator {
    -webkit-appearance: none;
    display: none;
    width: 0;
    opacity: 0;
  }

  .search-range p {
    font-style: italic;
  }
  .search-range input {
    background: none;
    border: none;
  }
  .search-box-container {
    background-color: white !important;
  }

  .search-close-icon {
    display: block !important;
  }

  /* stage 2. Entered */
  .drop-enter-active {
    animation: drop-down 0.2s ease-in-out forwards;
  }

  /* stage 3. leave */
  .drop-leave-active {
    animation: lift-up 0.2s ease-in-out forwards;
  }
  @keyframes drop-down {
    from {
      transform: translateY(-30%);
      opacity: 0;
    }

    to {
      transform: translateY(0);
      opacity: 1;
    }
  }

  @keyframes lift-up {
    from {
      transform: translateY(0px);
      opacity: 1;
    }

    to {
      transform: translateY(-30%);
      opacity: 0;
    }
  }
</style>
